import RequestHandler from "./RequestHandler";

function MaterialGroupsAPI() {
    const baseMaterialGroupsAPI = "material-groups";

    async function listMaterialGroups(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "name";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${baseMaterialGroupsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getMaterialGroup(groupId) {
        try {
            const result = await RequestHandler.get(
                `${baseMaterialGroupsAPI}/${groupId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function removeMaterialGroup(groupId) {
        try {
            const result = await RequestHandler.remove(
                `${baseMaterialGroupsAPI}/${groupId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function addMaterialGroup(group) {
        try {
            const result = await RequestHandler.post(
                `${baseMaterialGroupsAPI}`,
                group
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateMaterialGroup(group) {
        try {
            const result = await RequestHandler.put(
                `${baseMaterialGroupsAPI}`,
                group
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        listMaterialGroups,
        getMaterialGroup,
        removeMaterialGroup,
        addMaterialGroup,
        updateMaterialGroup,
    };
}

export default MaterialGroupsAPI();
